import { render, staticRenderFns } from "./FlightBookingCard.vue?vue&type=template&id=e42a62e0&scoped=true&"
import script from "./FlightBookingCard.vue?vue&type=script&lang=js&"
export * from "./FlightBookingCard.vue?vue&type=script&lang=js&"
import style0 from "./FlightBookingCard.vue?vue&type=style&index=0&id=e42a62e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42a62e0",
  null
  
)

export default component.exports